export var VaccineStatus;
(function (VaccineStatus) {
    VaccineStatus["ACTIVE"] = "active";
    VaccineStatus["EXPIRED"] = "expired";
    VaccineStatus["MISSING_EXPIRATION"] = "missing_expiration";
})(VaccineStatus || (VaccineStatus = {}));
export var DentalIds;
(function (DentalIds) {
    DentalIds["NoCleaning"] = "no_cleaning";
    DentalIds["NonAnestheticDental"] = "non_anesthetic_dental";
    DentalIds["AnestheticDental"] = "anesthetic_dental";
})(DentalIds || (DentalIds = {}));
